/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drop_Photo_HereInputs */

const en_drop_photo_here = /** @type {(inputs: Drop_Photo_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop Photo Here`)
};

const es_drop_photo_here = /** @type {(inputs: Drop_Photo_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suelta la foto aquí`)
};

const fr_drop_photo_here = /** @type {(inputs: Drop_Photo_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déposez la photo ici`)
};

const de_drop_photo_here = /** @type {(inputs: Drop_Photo_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto hier ablegen`)
};

const ja_drop_photo_here = /** @type {(inputs: Drop_Photo_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここに写真をドロップ`)
};

const zh_drop_photo_here = /** @type {(inputs: Drop_Photo_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将照片拖放到此处`)
};

const ar_drop_photo_here = /** @type {(inputs: Drop_Photo_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أفلت الصورة هنا`)
};

const id_drop_photo_here = /** @type {(inputs: Drop_Photo_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lepaskan Foto di Sini`)
};

const it_drop_photo_here = /** @type {(inputs: Drop_Photo_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilascia la foto qui`)
};

const ru_drop_photo_here = /** @type {(inputs: Drop_Photo_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перетащите фото сюда`)
};

const pt_drop_photo_here = /** @type {(inputs: Drop_Photo_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solte a foto aqui`)
};

const ko_drop_photo_here = /** @type {(inputs: Drop_Photo_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여기에 사진 놓기`)
};

/**
* | output |
* | --- |
* | "Drop Photo Here" |
*
* @param {Drop_Photo_HereInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const drop_photo_here = /** @type {((inputs?: Drop_Photo_HereInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drop_Photo_HereInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_drop_photo_here(inputs)
	if (locale === "es") return es_drop_photo_here(inputs)
	if (locale === "fr") return fr_drop_photo_here(inputs)
	if (locale === "de") return de_drop_photo_here(inputs)
	if (locale === "ja") return ja_drop_photo_here(inputs)
	if (locale === "zh") return zh_drop_photo_here(inputs)
	if (locale === "ar") return ar_drop_photo_here(inputs)
	if (locale === "id") return id_drop_photo_here(inputs)
	if (locale === "it") return it_drop_photo_here(inputs)
	if (locale === "ru") return ru_drop_photo_here(inputs)
	if (locale === "pt") return pt_drop_photo_here(inputs)
	return ko_drop_photo_here(inputs)
});